import React from 'react';
import { ReactComponent as ArrowRight } from 'images/new-icons/arrow-right.svg';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from './ForwardArrow.module.scss';

type Props = {
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
};

const ForwardArrow: React.FC<Props> = ({ onClick, className, style }) => {
  const { i18n } = useTranslation();

  return (
    <ArrowRight
        onClick={onClick}
        className={clsx(
            styles.arrow,
            { [styles.arrowRtl]: i18n.dir() === 'rtl' },
            className
        )}
        style={style}
    />
  );
};

export default ForwardArrow;
